/**
 * Paleta dos 23 grupos canônicos de cor da API (constante CORES no backend).
 *
 * São aproximações para o swatch do filtro, não referência de produto — vale
 * a Sara revisar. Metálicos e "colorido" usam gradiente porque uma cor chapada
 * não os representa; transparente é tratado à parte, com fundo xadrez.
 */
export const COLOR_SWATCHES: Record<string, string> = {
  VERMELHO: "#c62828",
  LARANJA: "#ef6c00",
  "ÂMBAR": "#d99b32",
  OCRE: "#c08b1f",
  AMARELO: "#f2c14e",
  VERDE: "#2e7d32",
  AZUL: "#1565c0",
  ANIL: "#303f9f",
  ROXO: "#6a1b9a",
  ROSA: "#e58cad",
  "ROUGE DE FER": "#b7410e",
  VINHO: "#6e1423",
  "SANGUE DE BOI": "#7b241c",
  MARROM: "#6d4c41",
  PRETO: "#1c1c1c",
  BRANCO: "#ffffff",
  CINZA: "#9e9e9e",
  BEGE: "#d8c3a5",
  CELADON: "#acc5b2",
  DOURADO: "linear-gradient(135deg, #b8860b 0%, #f5d67a 45%, #b8860b 100%)",
  PRATA: "linear-gradient(135deg, #8e8e8e 0%, #e8e8e8 45%, #8e8e8e 100%)",
  BRONZE: "linear-gradient(135deg, #7d5a2b 0%, #cd9a5b 45%, #7d5a2b 100%)",
  COBRE: "linear-gradient(135deg, #8a4523 0%, #d98a5f 45%, #8a4523 100%)",
  COLORIDO:
    "conic-gradient(#c62828, #ef6c00, #f2c14e, #2e7d32, #1565c0, #6a1b9a, #c62828)",
};

/** Sem cor definida na paleta: o componente cai para um swatch neutro. */
export const FALLBACK_SWATCH = "#d9d9d9";

export const TRANSPARENT_KEY = "TRANSPARENTE";

export function swatchFor(value: string): string {
  return COLOR_SWATCHES[value.toUpperCase()] ?? FALLBACK_SWATCH;
}

/** Cores claras precisam de borda para não sumir no fundo branco. */
export function needsOutline(value: string): boolean {
  return ["BRANCO", "TRANSPARENTE", "BEGE", "AMARELO"].includes(value.toUpperCase());
}
